import React from 'react';

function Analytics({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="M18.9 13C18.9552 13 19.0001 13.0448 18.9994 13.1C18.98 14.6474 18.5123 16.1567 17.6518 17.4446C16.7727 18.7602 15.5233 19.7855 14.0615 20.391C12.5997 20.9965 10.9911 21.155 9.43928 20.8463C7.88743 20.5376 6.46197 19.7757 5.34315 18.6569C4.22433 17.538 3.4624 16.1126 3.15372 14.5607C2.84504 13.0089 3.00347 11.4003 3.60897 9.93853C4.21447 8.47672 5.23985 7.22729 6.55544 6.34824C7.8433 5.48772 9.35264 5.01996 10.9 5.00063C10.9552 4.99993 11 5.04477 11 5.1V12.9C11 12.9552 11.0448 13 11.1 13H18.9Z" />
      <path d="M16.9874 3.49478C16.2296 3.18089 15.4195 3.01338 14.6 3.00077C14.5448 2.99992 14.5 3.04477 14.5 3.1L14.5 9.4C14.5 9.45523 14.5448 9.5 14.6 9.5L20.9 9.5C20.9552 9.5 21.0001 9.45522 20.9992 9.4C20.9866 8.58045 20.8191 7.77037 20.5052 7.01256C20.1786 6.22394 19.6998 5.50739 19.0962 4.90381C18.4926 4.30023 17.7761 3.82144 16.9874 3.49478Z" />
      <path d="M17.9418 16.9764C18.6186 15.7948 18.9824 14.4605 18.9994 13.1C19.0001 13.0448 18.9552 13 18.9 13H11.1746C11.0973 13 11.0492 13.0839 11.0883 13.1506L14.9965 19.8145C15.0244 19.8622 15.0858 19.8782 15.133 19.8497C16.298 19.1467 17.2649 18.158 17.9418 16.9764Z" />
    </svg>
  );
}

export default Analytics;
